<template lang="pug">
.f-title

</template>

<script lang="js">

export default {
  name: 'TitleField',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.f-title {

}
</style>
